<template lang="html">
  <div class="_modals">
    <b-modal 
      id="_request__quota"
      ref="modalRequestQuotaSchedule"
      centered
      hide-footer
      title=""
    >
      <div class="text-center heading">
        <p class="pt-4">Request Vessel Schedule</p>
      </div>
      <div class="row mt-4">
        <div class="col-md text-center">
          <p>You can request access for check vessel schedule. After the invitation was submitted, we will contact you as soon as posible</p>
          <button type="button" class="button__bluecorporite mt-3" @click="actionSendReqQuota">
            Request schedule
          </button>
          <p v-if="errorRequestQuota" class="global__texterror text-center mt-3">Oops... Something went wrong!</p>
        </div>
      </div>
    </b-modal>
    <b-modal 
      id="_request__quota__sent"
      ref="modalRequestQuotaScheduleSent"
      centered
      hide-header
      hide-footer
      hide-header-close
      title=""
    >
      <div class="row mt-4">
        <div class="col-md text-center">
          <img src="@/assets/image/icon/tick-circle.svg" class="mb-2" alt="tick-circle">
          <p>Your request to Vessel Schedule has been sent</p>
        </div>
      </div>
    </b-modal>
    <b-modal 
      id="_alert__remaining__quota"
      ref="modalAlertRemainingQuota"
      centered
      hide-footer
      title=""
    >
      <div class="text-center heading">
        <p class="pt-4">Your quota is {{ company ? company.ship_schedule_quota : '-' }} remaining</p>
      </div>
      <div class="row mt-4">
        <div class="col-md text-center">
          <p>You can request access to check vessel schedule or select only {{ company ? company.ship_schedule_quota : '-' }} shipping lines</p>
          <button type="button" class="button__bluecorporite mt-3" @click="actionSendReqQuota">
            Request schedule
          </button>
          <p v-if="errorRequestQuota" class="global__texterror text-center mt-3">Oops... Something went wrong!</p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      requestQuota: 'vesselSchedule/requestQuota',
      isLoadingRequestQuota: 'vesselSchedule/isLoadingRequestQuota',
      errorRequestQuota: 'vesselSchedule/errorRequestQuota',

      company: 'settingCompany/company'
    })
  },
  created () {
    this.$eventHub.$on('dialog-request-quota-schedule', this.dialogRequestQuotaSchedule)
    this.$eventHub.$on('dialog-alert-remaining-quota', this.dialogRemainingQuota)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-request-quota-schedule')
    this.$eventHub.$off('dialog-alert-remaining-quota')
  },
  methods: {
    closeModal: function () {
      this.$refs.modalRequestQuotaSchedule.hide()
    },
    dialogRequestQuotaSchedule: function () {
      this.$refs.modalRequestQuotaSchedule.show()
    },
    dialogRemainingQuota: function () {
      this.$refs.modalAlertRemainingQuota.show()
    },
    actionSendReqQuota () {
      this.$store.dispatch('vesselSchedule/SEND_REQ_QUOTA').then((res) => {
        if (!this.errorRequestQuota) {
          this.$refs.modalRequestQuotaSchedule.hide()
          this.$refs.modalAlertRemainingQuota.hide()
          this.$refs.modalRequestQuotaScheduleSent.show()

          setTimeout(() => {
            this.$refs.modalRequestQuotaScheduleSent.hide()
          }, 3000)
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/global/modals/VesselSchedule.vue